import React from "react"
import {
    Box,
    componentStyles,
    useColors,
} from "@mallardbay/lib-react-components"

import { TEST_IDS } from "~config/constants"

export default function ChatMessageStepSeparator() {
    const styles = useStyles()

    return (
        <Box
            style={styles.root}
            testId={TEST_IDS.CHAT_MESSAGE_STEP_SEPARATOR}
            role="separator"
        />
    )
}

function useStyles() {
    const colors = useColors()

    return componentStyles({
        root: {
            height: "1px",
            backgroundColor: colors.border,
            opacity: 0.5,
            marginY: 1,
        },
    })
}
